import { styled, css, Paper } from '@mui/material';

export const StyledCareDocumentContainer = styled(Paper)(
  ({ theme }) => css`
    margin-top: ${theme.spacing('LARGE')};
  `
);
export const StyledCareDocumentHeaderContainer = styled('div')(
  ({ theme }) => css`
    h2 {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }
  `
);
export const StyledCareDocumentBodyContainer = styled('div')(
  ({ theme }) => css`
    display: flex;
    column-gap: ${theme.spacing('LARGE')};

    p:nth-of-type(1) {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }

    p:nth-of-type(2) {
      margin-bottom: ${theme.spacing('MEDIUM')};
    }
    ${theme.breakpoints.up('desktop')} {
      p:nth-of-type(1) {
        margin-bottom: ${theme.spacing('MEDIUM')};
      }

      p:nth-of-type(2) {
        margin-bottom: ${theme.spacing('LARGE')};
      }
    }
  `
);
